import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstLxa: [],
		lxa: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
		lstLxq: [],
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getLoading: state => {
			return state.loading
		},
		getLxa(state) {
			let lxa = { ...state.lxa }
			lxa.lstLxq = state.lstLxq
			return lxa
		},
		getLxacaixa(state) {
			return state.lxa.lxacaixa
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
		getInsert: state => {
			return state.insert
		},
		getLstLxq: state => {
			return state.getLstLxq
		},
	},
	mutations: {
		set(state, lxa) {
			state.lxa = lxa
			if (lxa) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.lxa = null
		},
		setParamsDataTable(state, payload) {
			state.lstLxa = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setLxa(state, lxa) {
			state.lxa = lxa
		},
		setLxq(state, lxq) {
			state.lxq = lxq
		},
		setlstLxq(state, lstLxq) {
			state.lstLxq = lstLxq
		},
		setLstLxa(state, lstLxa) {
			state.lstLxa = lstLxa
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		setlstLxq: ({ commit }, lstLxq) => commit("setlstLxq", lstLxq),
		setLstDc4: ({ commit }, lstDc4) => commit("setLstDc4", lstDc4),
		setUpdate: ({ commit }, update) => commit("setUpdate", update),
		setInsert: ({ commit }, insert) => commit("setInsert", insert),
		setFormError: ({ commit }, error) => commit("setFormError", error),
		setLoading: ({ commit }, loading) => commit("setLoading", loading),
		async addAutLiquidation(store, lxq) {
			let lstLxq = store.state.lstLxq ?? []
			lstLxq.push(lxq)
			store.commit("setlstLxq", lstLxq)
		},
		initForm({ commit }) {
			commit("initForm")
		},
		async get({ dispatch }) {
			return await this._vm.$axios
				.get("/Oryx/FinancialParameters/Find")
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async find({ commit, dispatch }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get("/Oryx/FinancialParameters/Find")
				.then(response => {
					let lxa = Utils.ValidateAxiosResponse(response.data)
					commit("set", lxa)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Oryx/FinancialParameters/Insert", getters.getLxa)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setLxa", null)
					dispatch("find")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Oryx/FinancialParameters/Update", getters.getLxa)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					dispatch("find")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Oryx/FinancialParameters/Delete/${getters.getLxacaixa}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					dispatch("find")
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findAllAutLiquidations({ commit, dispatch }) {
			commit("setLoading", true)
			let payload = await this._vm.$axios
				.get("/Financial/FinancialLiquidation/FindList")
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setlstLxq", payload)
					return true
				})
				.catch(error => {
					commit("setlstLxq", [])
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
	},
}
